import React from 'react'

/* eslint-disable no-restricted-syntax */
type LocalStorageHook = [
  string | undefined | null,
  (value: string) => void,
  () => void,
]

export type LocalStorageKeys =
  | 'accessToken'
  | 'refreshToken'
  | 'userType'
  | 'infoOnesignal'
  | 'idLanguageOnesignal'
  | 'isLoggedIn'
  | 'acceptPrivacyPolicy'
  | 'acceptTermsOfUse'
  | 'addedJobs'
  | 'downloadAppBannerClosedUntil'
  | 'workerLoginPhoneNumber'
  | 'lang'
  | 'slowdownBannerClosed'
  | 'activeHublerTracking'
  | 'hiddenPoolRadiusCard'
  | 'hublerOnboardingContext'
  | 'hublerOnboardingSourceSignupCode'
  | 'hublerOnboardingSourceInstitution'
  | 'hublerOnboardingAppliedInstitutions'
  | 'onboardingFromProfile'
  | 'cioIdentified'

export const useLocalStorage = (key: LocalStorageKeys): LocalStorageHook => {
  const [storageState, setStorageState] = React.useState<string | null>(
    localStorage.getItem(key),
  )

  const writeLocalStorageState = React.useCallback(
    (value: string) => {
      setStorageState(value)
      localStorage.setItem(key, value)
    },
    [key],
  )

  const removeLocalStorageItem = React.useCallback(() => {
    localStorage.removeItem(key)
    setStorageState(null)
  }, [key])

  return [storageState, writeLocalStorageState, removeLocalStorageItem]
}
